var _WebSocketModel_instances, _a, _WebSocketModel_HTTPS_URL, _WebSocketModel_socket, _WebSocketModel_callback, _WebSocketModel_onOpen, _WebSocketModel_onClose, _WebSocketModel_onRawMessage;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
export class WebSocketModel {
    constructor() {
        _WebSocketModel_instances.add(this);
        _WebSocketModel_socket.set(this, null);
        _WebSocketModel_callback.set(this, void 0);
        _WebSocketModel_onOpen.set(this, void 0);
        _WebSocketModel_onClose.set(this, void 0);
        __classPrivateFieldSet(this, _WebSocketModel_socket, null, "f");
        __classPrivateFieldSet(this, _WebSocketModel_onOpen, () => { }, "f");
        __classPrivateFieldSet(this, _WebSocketModel_onClose, () => { }, "f");
        __classPrivateFieldSet(this, _WebSocketModel_callback, (_) => { }, "f");
    }
    setOnOpen(onOpen) {
        __classPrivateFieldSet(this, _WebSocketModel_onOpen, onOpen, "f");
    }
    setOnClose(onClose) {
        __classPrivateFieldSet(this, _WebSocketModel_onClose, onClose, "f");
    }
    send(request) {
        var _b;
        (_b = __classPrivateFieldGet(this, _WebSocketModel_socket, "f")) === null || _b === void 0 ? void 0 : _b.send(JSON.stringify(request));
    }
    onReceived(callback) {
        __classPrivateFieldSet(this, _WebSocketModel_callback, callback, "f");
    }
    connect() {
        const socket = new WebSocket(__classPrivateFieldGet(_a, _a, "f", _WebSocketModel_HTTPS_URL));
        socket.onopen = () => __classPrivateFieldGet(this, _WebSocketModel_onOpen, "f").call(this);
        socket.onmessage = (message) => __classPrivateFieldGet(this, _WebSocketModel_instances, "m", _WebSocketModel_onRawMessage).call(this, message);
        socket.onclose = () => __classPrivateFieldGet(this, _WebSocketModel_onClose, "f").call(this);
        __classPrivateFieldSet(this, _WebSocketModel_socket, socket, "f");
    }
    disconnect() {
        __classPrivateFieldGet(this, _WebSocketModel_socket, "f").close();
        __classPrivateFieldSet(this, _WebSocketModel_socket, null, "f");
    }
}
_a = WebSocketModel, _WebSocketModel_socket = new WeakMap(), _WebSocketModel_callback = new WeakMap(), _WebSocketModel_onOpen = new WeakMap(), _WebSocketModel_onClose = new WeakMap(), _WebSocketModel_instances = new WeakSet(), _WebSocketModel_onRawMessage = function _WebSocketModel_onRawMessage(messageEvent) {
    const data = JSON.parse(messageEvent.data);
    __classPrivateFieldGet(this, _WebSocketModel_callback, "f").call(this, data);
};
_WebSocketModel_HTTPS_URL = { value: 'wss://mycast.xyz:8002' };
